import { BehaviorSubject, Observable } from 'rxjs';
import { FeatureType } from '../../enums/module';
import { IModule } from './module';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  private enabledModulesSubject = new BehaviorSubject<IModule[]>([]);
  enabledModules$ = this.enabledModulesSubject.asObservable();
  private enabledFeaturesSubject = new BehaviorSubject<FeatureType[]>([]);
  enabledFeatures$ = this.enabledFeaturesSubject.asObservable();

  constructor(private http: HttpClient) {}

  getCompanyModules(): Observable<IModule[]> {
    return this.http.get<IModule[]>(
      `:API_BASE_URLcompany/modules?enabled=true`
    );
  }

  init(): Observable<FeatureType[]> {
    return this.getCompanyModules().pipe(
      tap((modules) => {
        this.enabledModulesSubject.next(modules);
      }),
      map((modules) => {
        const features = modules
          .flatMap((module) => module.features)
          .map((feature) => feature.name);

        this.enabledFeaturesSubject.next(features);
        return features;
      })
    );
  }
}
